import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Wrapper as CompiledWrapper } from './wrapper-compiled';
import { Wrapper as EmotionWrapper } from './wrapper-emotion';
export var Wrapper = function Wrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledWrapper, props) : /*#__PURE__*/React.createElement(EmotionWrapper, props);
};